module.exports = "<div class=\"content\" *ngIf=\" loading$ | async\">\n  <div class=\"progress\">\n    <div class=\"progress-bar progress-bar-striped progress-bar-animated bg-secondary w-100\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/loading/loading.component.html
// module id = 1094
// module chunks = 0